// extracted by mini-css-extract-plugin
var _1 = "dJMLM";
var _2 = "WIVc8";
var _3 = "uB8tK";
var _4 = "H8YkP";
var _5 = "gOlKP";
var _6 = "B5VEl";
var _7 = "s2F4D";
export { _1 as "fakeLink", _2 as "image", _3 as "imageWrapper", _4 as "isNeptune", _5 as "mapLink", _6 as "mapWrapper", _7 as "title" }
